import React from "react";
import css from "./FileView.module.css";


export default function FileView(props){
    const {content=props.code}=props;
    return (
        <div className={`${css.fileview} ${props.className||""}`} style={props.style}>
            <div className={css.linecount}>
                {content?.match(/<div>|<br>/g)?.map((_,i)=>(
                    <span key={"line"+i}>{i+1}</span>
                ))}
            </div>
            <div 
                className={css.content}
                contentEditable={true} 
                spellCheck="false" 
                autoCorrect="off" 
                autoCapitalize="off"
                dangerouslySetInnerHTML={{__html:content}}
                aria-readonly="true"
                onInput={process.env.NODE_ENV==="development"?undefined:({target})=>{
                    target.innerHTML=content;
                    target.blur();
                }}
            />
        </div>
    )
}

FileView.defaultProps={
    editable:process.env.NODE_ENV==="development",
}
